/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import closeIcon from '../../assets/images/x_icon_black.svg';

import { FormattedField } from '../common';

import './index.scss';

Modal.setAppElement('#root');

class BuyNumber extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      areadcode: '',
      country: 'US',
    };
    this.handleAreadChange = this.handleAreadChange.bind(this);
    this.BuyNumber = this.BuyNumber.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.carriers.buyPhoneNumberSuccess &&
      nextProps.carriers.buyingPhoneNumber !==
        this.props.carriers.buyingPhoneNumber
    ) {
      this.props.closeBuyModal();
      this.props.clearErrorMessage();
    }
  }

  componentDidMount() {}

  handleAreadChange(event) {
    this.setState({
      areadcode: event.target.value,
    });
    this.props.clearErrorMessage();
  }

  BuyNumber() {
    const { areadcode, country } = this.state;
    const { auth, business } = this.props;
    const bz_id = business?.id || auth?.studio_id;
    const params = {
      bz_id,
      country,
      area_code: areadcode,
    };
    this.props.getNewPhoneNumber(params);
  }

  render() {
    const { modelopen, closeBuyModal, carriers } = this.props;
    const { buyingPhoneNumber, errorMessage, buyPhoneNumberSuccess } = carriers;
    const { areadcode } = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeBuyModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title">Buy a number</div>
              <button className="modal-close" onClick={closeBuyModal}>
                <img src={closeIcon} />
              </button>
              <div className="modal-description">
                Please specify the area code for the number you’d like to purchase
              </div>
              <div className="input">
                <label className="label">Area Code</label>
                <div className="block-number">
                  <FormattedField
                    format="###"
                    value={areadcode}
                    classes={'area-code'}
                    onChange={this.handleAreadChange}
                  />
                </div>
                {!buyPhoneNumberSuccess && (
                  <div className="error-message">{errorMessage}</div>
                )}
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={this.BuyNumber}
                  disabled={buyingPhoneNumber || areadcode.length < 3}
                >
                  {buyingPhoneNumber ? 'BUYING...' : 'BUY'}
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={closeBuyModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default BuyNumber;
